import { createFileRoute } from '@tanstack/react-router'
import { EntryBrowserPage } from 'pages/entryBrowser/EntryBrowserPage'

import { entryBrowserSearchSchema } from './-searchParams'

const RouteComponent = () => {
  const searchParams = Route.useSearch()
  return <EntryBrowserPage searchParams={searchParams} />
}

export const Route = createFileRoute('/entry-browser/')({
  component: RouteComponent,
  validateSearch: entryBrowserSearchSchema,
  staticData: {
    title: 'Entry Browser',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
      hideSiteSelector: true,
    },
  },
})
